module.exports = function(service) {
	'use strict'
	service.factory('reqursiveService', reqursiveService);
	reqursiveService.$inject = [];
	function reqursiveService() {
	   return {
		   	getReqursiveArray :function(reqursiveObject) {
			   	var reqursiveArray = [];
	          	var print = function(categories) {
		            for (var i=0; i< categories.length; i++) {
		              reqursiveArray.push(categories[i]);
		              if(categories[i].children) {
		                print(categories[i].children);
		              }
		            }
	          	}
	          	print(reqursiveObject);
	          	return reqursiveArray
	        }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/reqursiveService.js
// module id = 624
// module chunks = 0